// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React from 'react';
import { Link } from 'react-router-dom';
import { parseDuration } from '../../../../../../../lib/utility';
import { AssessmentModule as AssessmentModuleType } from '../../../../../../../types/Model';

import { S } from './styles';

interface AssessmentModuleProps {
  active: boolean;
  module: AssessmentModuleType;
  to: string;
}

const AssessmentModule: React.FC<AssessmentModuleProps> = (props):JSX.Element => {
  const {
    active,
    module: {
      name,
      type,
      status,
      score
    },
    to
  } = props;

  return (
    <S.Container>
      <S.Link as={Link} to={to} active={active}>
        <S.TitleContainer>
          <S.Icon type={type}/>
          <S.Title>{name}</S.Title>
        </S.TitleContainer>
        <S.FooterContainer>
          {status && <S.CompletionStatusTag type={status} score={score}/>}
        </S.FooterContainer>
      </S.Link>
    </S.Container>
  );
}

export { AssessmentModule as default };
